import type {ReactAction} from '@netx/core/bootstrap';
import {faTrashAlt} from '@fortawesome/pro-solid-svg-icons';
import {canDeleteSavedSearch} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionDeleteIcon = faTrashAlt;

/**
 * Delete saved search
 * @param params
 * @returns Action
 */
export const searchSavedActionDelete = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-delete',
	cb: () => dispatcher.trigger(SEARCH_SAVED_EVENT.DELETE, savedSearch),
	enableTest: () => canDeleteSavedSearch(savedSearch),
	icon: searchSavedActionDeleteIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.DELETE;
	},
	...params,
});

export default searchSavedActionDelete;
